import { Theme } from "@material-ui/core/styles";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    borderTop: `1px solid ${theme.palette.text.hint}`,
    height: 67,
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      background: "transparent"
    }
  },
  horseNameLabelBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 302,
    width: 302,
    borderRight: `1px solid ${theme.palette.text.hint}`,
    boxShadow: "0 1px 7px 0 rgb(0, 0, 0, 0.08)"
  },
  sortLabel: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 16,
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  calendar: {
    display: "flex",
    overflow: "hidden"
  },
  monthContainerWrapper: {
    display: "flex",
    flexWrap: "nowrap"
  },
  monthContainer: {
    display: "flex",
    flexDirection: "column"
  },
  fake: {
    minWidth: 24,
    width: 24,
    minHeight: 66,
    height: 66,
    display: "flex"
  },
  monthTitle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f6f6f6",
    minHeight: 44,
    maxHeight: 44,
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    borderRight: `1px solid ${theme.palette.text.hint}`
  },
  monthName: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: "normal",
    textTransform: "uppercase",
    fontSize: 14
  },
  monthDateRange: {
    lineHeight: "normal",
    fontSize: 12
  },
  monthDates: {
    display: "flex",
    flexWrap: "nowrap"
  },
  monthDate: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 48,
    height: 22,
    borderRight: "1px solid #f7f7f7",
    fontSize: 10,
    lineHeight: "normal",
    color: "#8b8983",
    textAlign: "center",
    textTransform: "uppercase",
    "&:last-child": {
      borderRight: `1px solid ${theme.palette.text.hint}`
    }
  },
  scheduledDatesOnlyHeader: {
    alignItems: "center",
    width: "100%",
    padding: "8px 24px",
    height: 48,
    backgroundColor: "#f7f7f7"
  },
  sortByContainer: {
    display: "flex"
  },
  nextWorkout: {
    minWidth: 280
  },
  headerLabel: {
    display: "flex",
    paddingRight: 4,
    whiteSpace: "nowrap",
    alignItems: "center"
  },
  headerValue: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  grow: {
    flexGrow: 1
  }
}));
